"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MosQualityScoreManager = void 0;
const mos_quality_score_utils_1 = require("../util/mos_quality_score_utils");
class MosQualityScoreManager {
    constructor(_logger) {
        this.convertNqsStatsToCalculateMosParameters = (localOrRemote, currentStats, previousStats) => {
            const currentParticipantStats = currentStats[localOrRemote];
            const previousParticipantStats = previousStats[localOrRemote];
            // use average of current and previous stats if previous stats exist for jitter and round trip time
            const averageJitterMs = (0, mos_quality_score_utils_1.findAverageOrUndefined)(currentParticipantStats.jitterMs, previousParticipantStats.jitterMs);
            const roundTripTimeMs = (0, mos_quality_score_utils_1.findAverageOrUndefined)(previousStats.roundTripTimeMs, currentStats.roundTripTimeMs);
            return [averageJitterMs, roundTripTimeMs, currentParticipantStats.packetsLostPercent];
        };
        this.calculateMOS = (averageJitterMs, roundTripTimeMs, packetLostPercent) => {
            if (averageJitterMs == null || roundTripTimeMs == null || packetLostPercent == null) {
                this.logger.debug('Missing parameters for MOS calculation, returning undefined', {
                    averageJitterMs,
                    roundTripTimeMs,
                    packetLostPercent,
                });
                return undefined;
            }
            const effectiveLatency = roundTripTimeMs + averageJitterMs * 2 + 10;
            const initialRFactor = effectiveLatency < 160
                ? 93.2 - effectiveLatency / 40
                : 93.2 - (effectiveLatency - 120) / 10;
            // Found in TwilioCode (https://github.com/twilio/twilio-video.js/blob/master/lib/preflight/mos.ts#L24)
            //    and it helped resolve some issues with the MOS score being too high when packet loss was high.  Setting
            //    rFactor to 0, will cause the MOS score to be 1.
            const packetLossTooBigYn = packetLostPercent > initialRFactor / 2.5;
            const rFactor = packetLossTooBigYn ? 0 : initialRFactor - 2.5 * packetLostPercent;
            const mos = 1 + 0.035 * rFactor + 0.000007 * rFactor * (rFactor - 60) * (100 - rFactor);
            return mos;
        };
        this.logger = _logger.extend('sdk-chime-video:mos_quality_score_manager');
    }
    calculateScore(localOrRemote, currentStats, previousStats) {
        const params = this.convertNqsStatsToCalculateMosParameters(localOrRemote, currentStats, previousStats);
        const mos = this.calculateMOS(...params);
        const nqs = this.convertMOSScoreToNetworkQuality(mos);
        return nqs;
    }
    convertMOSScoreToNetworkQuality(mosValue) {
        if (typeof mosValue !== 'number') {
            return undefined;
        }
        let score = 0;
        if (mosValue > 4.2) {
            score = 5;
        }
        else if (mosValue > 4.0) {
            score = 4;
        }
        else if (mosValue > 3.6) {
            score = 3;
        }
        else if (mosValue > 3) {
            score = 2;
        }
        else if (mosValue > 0) {
            score = 1;
        }
        else {
            score = 0;
        }
        this.logger.debug('mosValue', mosValue, 'score', score);
        return score;
    }
}
exports.MosQualityScoreManager = MosQualityScoreManager;
//# sourceMappingURL=mos_quality_score_manager.js.map